// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content_8RPce","image":"index_image_X6gbF"};